import { useLDClient } from "launchdarkly-react-client-sdk";
import { useEffect, useState } from "react";

interface Flags {
  hasAccessToNewBo: boolean;
  hasCustomerReturnRateSegment: boolean;
  flagLoading: boolean;
}

export function useLDFlags({ shopId }: { shopId: string }): Flags {
  const [hasAccessToNewBo, setHasAccessToNewBo] = useState<boolean>(false);
  const [hasCustomerReturnRateSegment, setHasCustomerReturnRateSegment] =
    useState<boolean>(false);
  const [flagLoading, setFlagLoading] = useState<boolean>(true);

  const ldClient = useLDClient();
  async function identifyLDFlags(): Promise<
    (key: string, defaultValue: boolean) => boolean
  > {
    await ldClient?.identify({
      key: shopId,
      anonymous: false,
      custom: {
        shopId: shopId,
      },
    });

    return function callFlags(flagKey: string, defaultValue: boolean) {
      return ldClient?.variation(flagKey, defaultValue);
    };
  }

  const getFeatureFlagValue = async (
    flagKey: string,
    defaultValue: boolean,
  ): Promise<boolean> => {
    const getFlagValueByShopId = await identifyLDFlags();
    return getFlagValueByShopId(flagKey, defaultValue);
  };

  useEffect(() => {
    Promise.all([
      getFeatureFlagValue("newBo", false),
      getFeatureFlagValue("customer-return-rate-segment", false),
    ]).then(([hasNewBoAccess, hasReturnRateSegment]) => {
      setHasAccessToNewBo(hasNewBoAccess);
      setHasCustomerReturnRateSegment(hasReturnRateSegment);
      setFlagLoading(false);
    });
  }, [shopId, ldClient]);

  return { hasAccessToNewBo, hasCustomerReturnRateSegment, flagLoading };
}
